import React from 'react';

import WrappedBase from './WrappedBase';
import AddToCartButton from '../containers/AddToCartButton';

export default class AddToCartButtonProvided extends React.Component {
  render() {
    return (
      <WrappedBase>
        <AddToCartButton {...this.props} />
      </WrappedBase>
    );
  }
}
